// Spanish dictionary. Same keys as en.ts. Machine-assisted, reviewed for tokens.

export const es: Record<string, string> = {
  "dawn.era0": "La estepa abierta",
  "dawn.era1": "Los kanes",
  "dawn.era2": "Piedra e imperio",
  "dawn.era3": "La república",
  "dawn.era4": "Más allá del cielo",
  "dawn.lore0": "El cielo azul eterno cubre las primeras tiendas.",
  "dawn.lore1": "El estandarte del lobo se alza hacia el Cielo.",
  "dawn.lore2": "Desde Manzikert avanzas al corazón de Anatolia.",
  "dawn.lore3": "Tus cúpulas responden al Cielo.",
  "dawn.lore4": "De las cenizas nace un pueblo.",
  "dawn.lore5": "El Cielo deja de ser techo y se vuelve puerta.",
  "dawn.lore6": "Bajo cielos ajenos levantas tu tienda.",
  "dawn.lore7": "Ahora eres quien pastorea las estrellas.",
  "dawn.lore8": "La Vía Láctea se convierte en tu ruta.",
  "dawn.lore9": "Lees la primera luz del universo.",
  "dawn.lore10": "Se levanta el último velo.",
  "dawn.lore11": "El círculo se cierra; te espera el primer amanecer.",
  'common.continue': 'Continuar',
  'common.skip': 'Saltar',
  'common.next': 'Siguiente',
  'common.finish': 'Listo',
  'common.close': 'Cerrar',
  'common.back': 'Atrás',
  'common.send': 'Enviar',
  'common.begin': 'Comenzar',

  'hud.spoils': 'Botín',
  'hud.skillPts': 'Pts de habilidad',
  'hud.cosmic': 'Cósmico',
  'hud.population': 'Población',
  'hud.buildings': 'Edificios',
  'hud.autoOn': 'Recolección automática: activa',
  'hud.autoProgress': 'Recolección automática: {have}/{need} recolectores',
  'hud.nextBuilding': 'Próximo edificio',
  'hud.needPop': 'primero haz crecer la población',
  'hud.ascend': 'Ascender',

  'wave.next': 'Próxima oleada',
  'wave.waveN': 'Oleada {n}',
  'wave.bossN': 'Oleada de jefe ({n})',
  'wave.incoming': 'Oleada en camino',
  'wave.bossIncoming': 'Jefe en camino',
  'wave.now': 'YA',
  'wave.yourPower': 'Tu poder',
  'wave.enemyPower': 'Poder enemigo',
  'wave.conquer': 'Conquista de {planet}: era {goal}',
  'wave.conquered': '{planet} conquistado',

  // puerta de era (el jefe que bloquea cada avance de era)
  'gate.progress': '{boss} se reúne en la puerta: {pct}%',
  'gate.atGate': '¡{boss} en la puerta!',
  'gate.final': 'Última era alcanzada',
  'gate.summonTitle': 'La puerta se abre',
  'gate.summonSub': '{boss} se concentra en la puerta. Derrótalo para entrar en la siguiente era; si la rompe, tu linaje cae.',
  'gate.freeProgress': 'Siguiente era: {pct}%',
  'gate.cleared': 'Puerta rota',
  'gate.clearedSub': 'Una nueva era por delante',

  'banner.repelled': 'Oleada repelida',
  'banner.overrun': 'Aldea arrasada',
  'banner.onHorizon': '{enemy} en el horizonte',
  'banner.bossApproaches': 'El jefe marcha sobre la puerta',
  'banner.scattered': '{enemy} dispersados',
  'banner.brokeThrough': '{enemy} rompieron la línea',

  'milestone.autoTitle': 'Recolección automática desbloqueada',
  'milestone.autoSub': 'Tu gente ahora recolecta recursos por su cuenta.',
  'milestone.settlementNow': 'Tu asentamiento ahora es un {name}',
  'milestone.settlementGrows': 'Tu asentamiento crece',

  'intro.begin': 'Comenzar',
  'intro.tagline': 'Del polvo de la estepa al dominio del cielo.',
  'intro.story':
    'Bajo el cielo azul eterno, un puñado de tiendas en la estepa. No gobiernas al pueblo; eres la voluntad del cielo que lo guía. Asciende era tras era, renace más fuerte de tus cenizas cuando caigas, y ábrete a las estrellas hasta que el cielo deje de ser un techo y sea una patria a la que volver.',

  'news.title': 'Novedades',
  'news.sub': 'Lo que cambió desde tu última visita (v{version})',
  'news.all': 'Todas las novedades',

  'tut.s1.title': 'Bienvenido',
  'tut.s1.text':
    'Esta es tu gente. Toca donde quieras recolectar; el círculo amarillo se asienta ahí y trabaja los árboles, rocas y mineral cercanos. Toca en otro lugar para moverlo (en el ordenador sigue el ratón).',
  'tut.s2.title': 'Recursos',
  'tut.s2.text': 'La madera, la piedra, el mineral y el conocimiento que reúnes se acumulan aquí.',
  'tut.s3.title': 'Tu asentamiento',
  'tut.s3.text':
    'Tu gente construye por su cuenta con estos recursos. Aquí se muestran la población, la cantidad de edificios y lo que necesita el próximo edificio.',
  'tut.s4.title': 'Oleadas',
  'tut.s4.text':
    'Los saqueadores llegan por intervalos. Si tu poder es suficiente, los repeles; si una oleada te supera, tu linaje cae y renaces con sabiduría.',
  'tut.s5.title': 'El resto depende de ti',
  'tut.s5.text':
    'Cada era posterior está custodiada por un jefe en la puerta: derrótalo para ganar un artefacto y elegir un rumbo (economía, ejército, conocimiento). 🔬 tecnología, 👤 cuenta y comentarios. ¡Diviértete!',

  'account.title': 'Cuenta',
  'account.feedbackLabel': 'Comentarios',
  'account.feedbackPlaceholder': '¿Qué opinas? Errores, ideas, sensaciones... todo ayuda.',
  'account.dangerZone': 'Zona de peligro',
  'account.resetBtn': 'Borrar todo el progreso (empezar de cero)',
  'account.resetConfirm':
    '¿Estás seguro? Se borrarán el árbol de habilidades, lo cósmico, los planetas y la partida actual. Esto no se puede deshacer.',
  'account.resetYes': 'Sí, borrar todo',
  'account.resetNo': 'Cancelar',
  'account.replayTutorial': 'Mostrar la guía otra vez',
  'account.logout': 'Cerrar sesión',
  'account.signIn': 'Inicia sesión para guardar mi progreso',
  'account.guest': 'Juegas como invitado. Tu progreso está solo en este dispositivo.',
  'account.language': 'Idioma',
  'account.supportLabel': 'Apoyo',
  'account.supportBtn': 'Apoya este juego',

  'nudge.early': '¿Cómo va todo? Una nota rápida ayuda mucho 🙏',
  'nudge.later': '¡Llegaste hasta aquí! ¿Nos cuentas qué opinas?',
  'nudge.cta': 'Comentarios',

  'login.title': 'Iniciar sesión',
  'login.sub':
    'Inicia sesión para conservar tu progreso en todos tus dispositivos. Puedes omitirlo y entrar cuando quieras desde 👤.',
  'login.guest': 'Juega ya, inicia sesión después',
  'login.emailPlaceholder': 'tu@correo.com',
  'login.sendCode': 'Enviar código',
  'login.codePlaceholder': 'Código de 6 dígitos',
  'login.verify': 'Verificar',
  'login.sending': 'Enviando...',
  'login.codeSent': 'Se envió un código a tu correo.',
  'login.verifying': 'Verificando...',
  'login.errGeneric': 'Algo salió mal, inténtalo de nuevo.',
  'login.errCode': 'El código es incorrecto o caducó.',

  'death.title': 'Tu linaje ha caído',
  'death.lede':
    'Llegaste a la Era {age}. Oleadas resistidas: {waves}. Gasta tu sabiduría ganada con esfuerzo y vuelve a levantarte.',
  'death.bossLede':
    'El jefe de era {boss} rompió tu puerta en la Era {age}. Oleadas resistidas: {waves}. Pon tus nuevos puntos en defensa antes de enfrentarlo de nuevo.',
  'death.wavesHeld': 'Oleadas resistidas',
  'death.ageReached': 'Era alcanzada',
  'death.skillPoints': 'Puntos de habilidad',
  'death.restart': 'Levántate de nuevo',
  'death.ascendTo': '🚀 Asciende a {planet} (+{gain} cósmico)',

  'offline.title': 'Mientras no estabas',
  'offline.sub': 'Tu gente siguió trabajando durante {time}.',
  'offline.collect': 'Recoger',

  'cards.title': 'Cambia una era',
  'cards.sub': 'Elige un rumbo para tu gente.',

  'cat.economy': 'Economía',
  'cat.military': 'Militar',
  'cat.knowledge': 'Conocimiento',
  'lab.active': 'Activo',
  'lab.cost': 'Costo',
  'lab.title': 'Laboratorio',
  'lab.spoilsWord': 'Botín',
  'lab.techs': 'Tecnologías (botín)',
  'lab.artifacts': 'Artefactos (activar con recursos)',
  'lab.artifactsHint': 'Derrota al jefe de era en cada puerta de edad para reclamar su artefacto.',

  'err.invalid_email': 'Introduce un correo válido.',
  'err.send_failed': 'No se pudo enviar el código, inténtalo de nuevo.',
  'err.missing_fields': 'Faltan datos.',
  'err.need_code': 'Primero pide un código.',
  'err.too_many_attempts': 'Demasiados intentos. Pide un código nuevo.',
  'err.code_expired': 'El código ha caducado.',
  'err.code_wrong': 'El código es incorrecto.',
  'err.invalid_save': 'Datos de guardado no válidos.',
  'err.empty_feedback': 'El comentario está vacío.',
  'err.auth_required': 'Debes iniciar sesión.',
  'account.feedbackEmpty': 'Escribe algo primero.',
  'account.feedbackThanks': '¡Gracias, enviado!',
  'account.feedbackError': 'No se pudo enviar, inténtalo de nuevo.',
  'account.btnTitle': 'Cuenta y comentarios',
  'milestone.ageDawns': 'Amanece la Era {n}',
  'milestone.synergy': 'Sinergia: {name}',
  'milestone.artifactFound': 'Artefacto encontrado: {name}',
  'milestone.artifactHint': 'Actívalo con recursos',
  'milestone.artifactActive': '{name} activado',
  'milestone.conquerReady': '{planet} es tuyo',
  'milestone.conquerReadySub': 'Asciende para guardar poder cósmico y tomar el siguiente mundo',
  'milestone.ascended': 'Ascendiste a {planet}',
  'milestone.ascendedSub': '+{gain} de poder cósmico',
  'combat.dodge': '¡Esquiva!',
  'combat.miss': 'Fallo',
  'combat.block': 'Bloqueo',
  'lab.owned': 'Adquirido',
  'lab.activate': 'Activar',
  'ui.soundTitle': 'Sonido sí/no',
  'login.signedIn': 'sesión iniciada',
  'login.offline': 'sin conexión',
  'skill.lv': 'Nv {lvl}/{max}',
  'skill.max': 'MÁX',
  'offline.nothing': 'No se recolectó nada en tu ausencia.',
  'death.firstLede': 'Esto no es el final: es el ciclo. Cada caída paga sabiduría. Gástala y vuelve más fuerte.',
  'death.spendHint': 'Gasta tus puntos y vuelve a alzarte.',
  'err.google_failed': 'Error al iniciar sesión con Google.',
  'login.or': 'o',

  // Wave skip + voluntary retirement (v0.10)
  'wave.sendNow': 'Enviar oleada ya',
  'retire.btn': 'Terminar civilización',
  'retire.lockedAt': 'Se abre en la Era {n}',
  'retire.confirm': 'Toca otra vez para terminar',
  'death.retireLede': 'Cerraste esta estirpe por decisión propia: Era {age}, {waves} oleadas resistidas. Gasta la sabiduría y funda una más fuerte.',
};
